// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BankVTBPure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="75" height="62" viewBox="0 0 75 62">
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M56.578 30.5H10.204s1.398 4.483 3.02 6.778h41.26s7.875 6.173 11.642 16.962h-43.37C15.273 48.137 9.669 39.888 6.726 30.5c.373-1.15.787-2.28 1.24-3.388h48.59c3.79-2.634 7.555-6.78 7.555-6.78H11.366c.7-1.16 1.444-2.29 2.233-3.385h53.27c1.406-1.705 4.232-6.78 4.232-6.78H19.474a49.657 49.657 0 0 1 3.902-3.387h49.309C74.035 3.543 75 0 75 0H21.44C11.204 7.285 3.487 17.96 0 30.5c3.458 12.4 11.104 23.158 21.414 30.512H74.86s-.94-16.227-18.282-30.513z"
      opacity=".2"
    />
  </svg>,
);

export const BankVTBIcon: React.SFC<{ iconClassName?: string; style?: React.CSSProperties }> = props => (
  <BankVTBPure className={props.iconClassName} style={props.style} />
);

BankVTBIcon.displayName = 'BankVTBIcon';
